import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { SizeGuideServices } from "../../../services";
import { IBaseItem } from "../types";

const SelectSizeGuideType = (props: any) => {
  const [sizeGuideTypes, setSizeGuideTypes] = useState<IBaseItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedType, setSelectedType] = useState<number>(0);

  // console.log('SELECT SIZE GUIDE TYPE', props);

  useEffect(() => {
    (async () => {
      const TypesSizeGuide = await SizeGuideServices.GetTypesSizeGuide();

      setSizeGuideTypes(TypesSizeGuide);
      setIsLoading(false);
    })();
  }, []);

  const onControlChange = (e: any) => {
    setSelectedType(parseInt(e.target.value));

    if (props.SuscribedChange) props.SuscribedChange(parseInt(e.target.value));
  };

  return (
    <>
      <Form.Group
        className={`justify-content-center ${props.ClassGroup || ""}`}
      >
        <Form.Label className="font-label-form">{props.Label || ""}</Form.Label>
        {isLoading ? (
          <></>
        ) : (
          <Form.Select
            size="sm"
            disabled={props.Disabled || false}
            onChange={(e: any) => onControlChange(e)}
            key={"select-type-sizeguide"}
            defaultValue={
              props.DefaultValue && sizeGuideTypes.length > 0
                ? props.DefaultValue
                : undefined
            }
          >
            {sizeGuideTypes?.map((element: IBaseItem, index: number) => {
              return (
                <option
                  value={element.Id}
                  key={`select-type-sizeguide-${element.Id}`}
                >
                  {element.Name}
                </option>
              );
            })}
          </Form.Select>
        )}
      </Form.Group>
    </>
  );
};

export default SelectSizeGuideType;
